module.exports = __webpack_public_path__ + "assets/img/17_1038.55efea7e.jpg";